import { configureStore } from "@reduxjs/toolkit"
import { useDispatch, useSelector } from "react-redux"
import { setupListeners } from "@reduxjs/toolkit/query"
import { globalErrorMiddleware } from "../api/globalErrorMiddleware"
import storeFiltersSlice from "store/slices/storeFiltersSlice"
import { api } from "./api"
import { AuthSlice } from "./slices/authSlice"
import MiningSlice from "./slices/miningSlice"
import { AppSlice } from "./slices/appSlice.ts"
import ElixirSlice from "./slices/elixirsSlice"
import { UserSlice } from "./slices/userSlice.ts"
import InventorySlice from "./slices/inventorySlice"
import { commonSlice } from "./slices/commonSlice.ts"
import { AuctionSlice } from "./slices/auctionSlice.ts"
import ExpeditionsSlice from "./slices/expeditionSlice"
import deviceInfoSlice from "./slices/deviceInfoSlice.ts"
import { FeaturesSlice } from "./slices/featuresSlice.ts"
import { ProfessionsSlice } from "./slices/professionsSlice"
import GenesisPreformsSlice from "./slices/genesisPreformSlice"

export const store = configureStore({
  devTools: import.meta.env.DEV,
  reducer: {
    [UserSlice.name]: UserSlice.reducer,
    [MiningSlice.name]: MiningSlice.reducer,
    [commonSlice.name]: commonSlice.reducer,
    [ProfessionsSlice.name]: ProfessionsSlice.reducer,
    [ExpeditionsSlice.name]: ExpeditionsSlice.reducer,
    [ElixirSlice.name]: ElixirSlice.reducer,
    [GenesisPreformsSlice.name]: GenesisPreformsSlice.reducer,
    [InventorySlice.name]: InventorySlice.reducer,
    [api.reducerPath]: api.reducer,
    [storeFiltersSlice.reducerPath]: storeFiltersSlice.reducer,
    [AppSlice.name]: AppSlice.reducer,
    [deviceInfoSlice.name]: deviceInfoSlice.reducer,
    [AuctionSlice.name]: AuctionSlice.reducer,
    [AuthSlice.name]: AuthSlice.reducer,
    [FeaturesSlice.name]: FeaturesSlice.reducer
  },
  middleware: (getDefaultMiddleware) => {
    const middleware = getDefaultMiddleware()

    return middleware.concat(api.middleware, globalErrorMiddleware)
  }
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector = <T,>(cb: (state: RootState) => T) =>
  useSelector(cb)

setupListeners(store.dispatch)
